import { ref } from 'vue';
import http from './http';
import useUser from './useUser'

export default function () {
    const loading = ref(false);
    const showTermChangeModal = ref(false);
    const termsChangelist = ref();
    const scrollbarRef = ref(null);

    const { onLogout } = useUser();

    function readChangeList() {
        loading.value = true;
        http.request("get", "/api/app/term/changeslist").then(res => {
            if (res.Type == 200) {
                if (res.Data != null) {                  
                    termsChangelist.value = res.Data.sort((a, b) => a.Sort - b.Sort);
                    //console.log("termsChangelist", termsChangelist.value);
                    if(termsChangelist.value.length > 0) {
                        showTermChangeModal.value = true;
                    }
                   
                }
            }
        }).finally(() => {
            loading.value = false;
        });

       
    }


    function onDecline() {
        onLogout();
    }

    function onAccept() {
        
        loading.value = true;
         
        http.request("post", "/api/app/term/acceptchanges").then(res => {
            if (res?.Type == 200) {
                //console.log("acceptchanges", res.Data);
                showTermChangeModal.value = false;
            } 
        }).finally(() => {
            loading.value = false;
        });
    }

    
   

    return { loading, readChangeList, showTermChangeModal, termsChangelist, scrollbarRef, onDecline, onAccept }
}
